// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_qv-5";
export var filledCircle = "_qv-4";
export var historyEntry = "_qv-3";
export var messageSideLeft = "_qv-1";
export var messageSideRight = "_qv-2";
export var orderTrackingCarouselWrapper = "_qv-6";
export var orderTrackingInfoContainer = "_qv-0";